import { getPublicityId, sendPublicity } from "../../interpreter/publicity";
import React, { useState } from "react";
import AppDataTable from "./AppDataTable";
import PublicitySee from "../modals/seedPublicityId";
import Icon from '@mdi/react';
import { mdiInformationOutline , mdiUpdate , mdiEmailFastOutline } from '@mdi/js';

export const PublicityList = ({ openModal, publicitys, loading = false }) => {
    const [selectedPublicity, setSelectedPublicity] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleViewDetails = async (id) => {
        try {
            const publicity = await getPublicityId(id);
            if (publicity) {
                setSelectedPublicity(publicity.data.getPublicityId.publicity);
                setIsModalOpen(true);
            }
        } catch (error) {
            //console.log('Error al obtener detalles de la publicidad:', error);
            return [];
        }
    };

    const handleSendPublicity = async(id) => {
        try {
            
            const publicitySend = await sendPublicity(id);
            
            if(publicitySend){
                alert('Envio exitoso de las publicidades!!');
            }else{
                alert('Surgio un problema en el envio de publcidades!!');
            }

        } catch ( err ){
            alert('Se produjo un error en el servidor.');
            console.warn('error es: ' , err);
        }
    }

    const columns = [
        { name: "Cod", selector: row => `00${row.id}`, sortable: true, center: true, width: "100px" },
        { name: "Nombre Comercial", selector: row => row.commercialName, sortable: true, center: true, width: "320px" },
        { name: "Categoría", selector: row => row.category?.description ?? "N/A", sortable: true, center: true, width: "140px" },
        { name: "Estado", selector: row => (row.status == 1 ? "Activo" : "Deshabilitado"), sortable: true, center: true, width: "190px" },
        {
            name: "Acciones",
            cell: (row) => (
                <div className="flex flex-row sm:flex-row sm:space-x-2 space-y-2 sm:space-y-0 justify-center">
                    <button 
                        onClick={() => openModal('reset', row)} 
                        className="bg-red-600 hover:bg-red-400 text-white text-xs sm:text-sm py-1 px-2 rounded flex items-center justify-center gap-2 w-full sm:w-auto"
                        title="Modificar"
                    >
                    <Icon path={mdiUpdate} size={1.2} />
                    </button>
                    <button 
                        onClick={() => handleViewDetails(row.id)} 
                        className="bg-blue-500 hover:bg-blue-600 text-white text-xs sm:text-sm py-1 px-2 rounded flex items-center justify-center gap-2 w-full sm:w-auto"
                        title="Ver Detalles"
                    >
                    <Icon path={mdiInformationOutline} size={1.2}/>
                    </button>
                    <button 
                        onClick={() => handleSendPublicity(row.id)} 
                        className="bg-blue-500 hover:bg-blue-300 text-white text-xs sm:text-sm py-1 px-2 rounded flex items-center justify-center gap-2 w-full sm:w-auto"
                        title="Enviar Pubiclidad"
                    >
                        <Icon path={mdiEmailFastOutline} size={1.2} />
                    </button>
                </div>
            ),
            center: true,
            width: "350px"
        },
    ];

    return (
        <div>
        {loading ? (
          // ✅ Spinner animado con Tailwind CSS (sin consumir recursos)
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid"></div>
          </div>
        ) : (
        <>
            <AppDataTable
                columns={columns}
                data={Array.isArray(publicitys) ? publicitys : []}
                scrollHeight="400px"
                noDataComponent={<p className="text-gray-500 py-4">No hay publicidad disponible.</p>}
                customStyles={{
                    headCells: {
                        style: {
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize:"18px",
                            justifyContent: "center",
                            backgroundColor: "#f3f4f6",
                            padding: "12px",
                        },
                    },
                    cells: {
                        style: {
                            textAlign: "center",
                            justifyContent: "center",
                            minHeight: "50px",
                            paddingTop: "8px",
                            paddingBottom: "8px",
                        },
                    },
                }}
            />
            <PublicitySee
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                publicity={selectedPublicity}
            />
        </>
    )}
    </div>
    );
};
